<template>
  <div id="hit-roundet-cells" v-bind:style="{'background-color': survey.badge.bg, 'border-color': survey.badge.accent}">

    <div class="hit-banderole-container"><a class="hit-banderole hit-html-a" href="https://hitklick.com" target="_blank" v-bind:style="{'color': survey.badge.pluscolor, 'background-color': survey.badge.accent}"><b>hitklick</b>.com</a></div>

    <div class="hit-title" v-bind:style="{color: survey.badge.text}">{{ survey.name }}</div>
    <div class="hit-top-stars" v-if="survey.all"v-bind:style="{color: survey.badge.text}">{{ survey.all_percent }} von 5 Sternen</div>

    <div class="hit-top-stars" v-if="!survey.all" v-bind:style="{color: survey.badge.text}">{{ $tc("message.noEntry", survey.all) }}</div>

    <div class="hit-stars"><hit_stars :stars="survey.all_percent" v-bind:style="{'color': survey.badge.accent}" /></div>

    <div class="hit-proz-container" v-for="star in sort_votes" v-bind:key="star+'sdasd'">
      <div class="hit-proz-count" v-bind:style="{'background-color': survey.badge.accent, 'color': survey.badge.pluscolor}">{{ star[1] }}</div>
      <div class="hit-proz-stars" v-bind:style="{'background-color': survey.badge.pluscolor}">
        <hit_stars :stars="star[0]" v-bind:style="{'color': survey.badge.accent}" />
      </div>

    </div>

    <div class="hit-votes" v-bind:style="{color: survey.badge.text}"><i class="hit-glyphicon hit-glyphicon-user"></i> {{ survey.all }} {{ $tc("message.feedback", survey.all) }}</div>
    <div class="hit-validated" v-if="survey.all" v-bind:style="{color: survey.badge.text}">{{ $t("message.validation") }}: 100%</div>

  </div>
</template>

<script>

export default{

  name: 'cells',
  props: { global: Object, survey: Object, avg: Object, stars: Array },

  computed: {

    stars_reverse: function () {
      var rev = JSON.parse(JSON.stringify(this.stars))

      return rev.reverse()
    },

    sort_votes: function () {
      var votes = this.survey.votes

      var sortable = []

      for (var vote in votes) {
        sortable.push([vote, votes[vote]])
      }

      sortable.sort(function (a, b) {
        return a[1] - b[1]
      })

      sortable = sortable.reverse()

      return sortable
    }

  },
  methods: {

    get_width: function (star) {
      if (!this.survey.percent[star]) { return {} }

      const width = (this.survey.percent[star] / 100) * 150

      return {width: width + 'px'}
    },

    get_avg_star_class: function (key) {
      if (Number.isInteger(this.survey.all_percent) == false && (key - this.survey.all_percent) < 1 && key > this.survey.all_percent) { return {'hit-glyphicon-star-half': true} } else if (key <= this.survey.all_percent) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    },
    get_avg_star_class2: function (index, key) {
      if (key >= index) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    }
  }

}

</script>

<style scoped>

#hit-roundet-cells{
  text-align: center;
  width: 280px;
  border: 1px solid darkgrey;
  font-family: Arial;
  font-size: 12pt;
  overflow: hidden;
  box-shadow: 0px 10px 20px -10px black;
  background-color: lightgrey;
  padding-bottom: 10px;
  display: inline-block;
}

#hit-roundet-cells .hit-banderole-container{
  text-align: left;
  position: absolute;

  padding-top: 14px;

  overflow: hidden;
  height: 70px;

}

#hit-roundet-cells .hit-banderole{
  margin-left: -21px;
  font-size: 8pt;
  background-color: darkgrey;
  position: relative;
  padding: 2px 10px;
  color: white;
  transform: rotate(-45deg);
  width: 100px;
  text-align: center;
  display: inline-block;

}

#hit-roundet-cells .hit-title{
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 40px;
  font-size: 12px;
  line-height: 0.9em;
}

#hit-roundet-cells .hit-top-stars{
  font-size: 16pt;
  font-weight: bold;
}

#hit-roundet-cells .hit-stars{
    margin-bottom: 20px;
  font-size: 18pt;
}

#hit-roundet-cells .hit-proz-count{
  display: block;
  width: 50px;
  background-color: #717c80;
  padding: 8px;
  font-size: 17px;

  height: 40px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  color: white;
  float:left;
  box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.5);
}

#hit-roundet-cells .hit-proz-stars{
  display: block;
  width: 200px;
  background-color: white;
  padding: 8px;
  font-size: 20px;
  line-height: 0;
  height: 40px;

  border-radius: 8px;

  box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.5);
}

#hit-roundet-cells .hit-proz-stars i{
  margin-right: 5px;
}
#hit-roundet-cells .hit-proz-stars i:last-of-type{
  margin-right: 0;
}

#hit-roundet-cells .hit-votes{
margin-top: 10px;
}

#hit-roundet-cells .hit-validated{
  font-size: 10px;
  margin-top: 10px;
}

#hit-roundet-cells .hit-proz-container{
  margin-bottom: 8px;
  text-align: center;
  display: inline-block;
}
</style>
